// src/serivces/api.js
import axios from "axios";
import axiosInstance from "./axiosInstance";

// const BASE_URL = "http://10.200.39.222:8000";
//const BASE_URL = "http://10.200.39.100:8080";
 const BASE_URL = "https://api.themailwhale.in";

export const signUpApi = async (payload) => {
  try {
    console.log("📦 Sending to CompleteDeliveryProfile:", payload);
    const response = await axiosInstance.post(
      `${BASE_URL}/api/accounts/delivery/CompleteDeliveryProfile/`,
      payload,
    );
    console.log("✅ API Success:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ SIGNUP ERROR:", error.response?.data || error.message);
    throw error;
  }
};

// Buildings list on base on pincode
export const fetchBuildingsByPincode = async (pin_code) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/api/mobile/delivery/buildings/by-pincode/?pin_code=${pin_code}`,
    );

    return response.data; // assuming backend returns { success: true, data: [...] }
  } catch (error) {
    // console.error(
    //   "❌ BUILDING FETCH ERROR:",
    //   error.response?.data || error.message
    // );
    throw error;
  }
};

// Verify Resident
export const verifyResidentAPI = async (payload) => {
  try {
    // Build query string from payload object
    const queryParams = new URLSearchParams(payload).toString();
    const url = `${BASE_URL}/api/mobile/delivery/resident-verify/?${queryParams}`;
    const response = await axios.get(url);

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// image uploading link
export const uploadShippingLabelsAPI = async (formData) => {
  try {
    // Debug: Log all form data entries
    console.log("📦 FormData Contents:");
    for (const pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    // Debug: Log headers
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    console.log("🧾 Headers:", headers);

    const response = await axiosInstance.post(
      `${BASE_URL}/api/mobile/delivery/resident-upload-shipping-labels/`,
      formData,
      {
        headers,
      },
    );

    console.log("✅ uploadShippingLabelsAPI Response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "❌ uploadShippingLabelsAPI Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// New function to fetch residents by flat
export const fetchResidentsByFlat = async (payload) => {
  console.log("📦 fetchResidentsByFlat Payload:", payload);
  try {
    const response = await axios.get(
      `${BASE_URL}/api/mobile/delivery/get-flat-residents/`,
      {
        params: payload, // ← Correct way for GET query params
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "❌ RESIDENT FETCH ERROR:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export function cleanApprovalUrl(rawUrl) {
  const hexDecoded = rawUrl.replace(/\\x([0-9a-fA-F]{2})/g, (_, hex) =>
    String.fromCharCode(parseInt(hex, 16)),
  );
  return hexDecoded.replace(/\\/g, ""); // remove stray backslashes
}

// Cleans + shortens one approval URL
export async function generateResidentApprovalLink(rawUrl) {
  try {
    const cleanedUrl = cleanApprovalUrl(rawUrl);
    const encodedUrl = encodeURIComponent(cleanedUrl);

    const response = await axiosInstance.get(
      `https://tinyurl.com/api-create.php?url=${encodedUrl}`,
    );

    return response.data; // just the shortened TinyURL string
  } catch (error) {
    console.error(
      "❌ Failed to generate TinyURL:",
      error.response?.data || error.message,
    );
    throw error;
  }
}

// export const convertToTinyURLs = async (input) => {
//   try {
//     const urls = Array.isArray(input) ? input : [input]; // normalize input

//     console.log("🌐 URLs to convert:");
//     urls.forEach((url, i) => console.log(`🔗 [${i + 1}]`, url));

//     const headers = {
//       "Content-Type": "application/x-www-form-urlencoded",
//     };

//     const tinyURLs = await Promise.all(
//       urls.map(async (url) => {
//         const response = await axiosInstance.get(
//           `https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`,
//           { headers },
//         );
//         return response.data;
//       }),
//     );

//     console.log("✅ TinyURLs:", tinyURLs);
//     return tinyURLs;
//   } catch (error) {
//     console.error(
//       "❌ convertToTinyURLs Error:",
//       error.response?.data || error.message,
//     );
//     throw error;
//   }
// };

// export const convertToTinyURLs = async (input) => {
//   try {
//     const urls = Array.isArray(input) ? input : [input]; // normalize input

//     console.log("🌐 URLs to convert:");
//     urls.forEach((url, i) => console.log(`🔗 [${i + 1}]`, url));

//     const headers = {
//       "Content-Type": "application/x-www-form-urlencoded",
//     };

//     const tinyURLs = await Promise.all(
//       urls.map(async (url) => {
//         const response = await axiosInstance.get(
//           `https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`,
//           { headers },
//         );
//         return response.data;
//       }),
//     );

//     console.log("✅ TinyURLs:", tinyURLs);
//     return tinyURLs;
//   } catch (error) {
//     console.error(
//       "❌ convertToTinyURLs Error:",
//       error.response?.data || error.message,
//     );
//     throw error;
//   }
// };

// sending full session
export const sendDeliverySessionAPI = async (sessionData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/mobile/delivery/resident-session/`,
      sessionData,
      {
        headers: {
          "Content-Type": "application/json", // ✅ Required
        },
      },
    );
    console.log("✅ Delivery Session API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "❌ Delivery Session Send Failed:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// checking parcel approval status form s3
export const monitorResidentAuth = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/mobile/delivery/monitor-resident-auth/`, // replace with correct endpoint
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    console.log("✅ monitorResidentAuth response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "❌ monitorResidentAuth error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Send Message API (SMS)
export const sendMessageAPI = async (payload) => {
  try {
    const url = `${BASE_URL}/api/accounts/msg-services/`;
    console.log("📨 Sending Message API:", url);
    console.log("📦 Payload:", payload);

    const response = await axios.post(url, payload, {
      headers: { "Content-Type": "application/json" },
    });

    console.log("✅ Message sent successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "❌ Message Send Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// QR code for delivery session
export const sessionQrcodeGenerate = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/mobile/delivery/resident-session-qrcode-generate/`, // ✅ Correct endpoint
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "❌ session qrcode error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// adding Pending Deliveries
export const addingPendingDeliveries = async (payload) => {
  try {
    const url = "/api/mobile/delivery/pending-deliveries/create/";
    console.log("🌐 Adding Pending Delivery:", url);
    console.log("📦 Payload:", payload);

    const response = await axiosInstance.post(url, payload);

    console.log("✅ Pending Delivery Created:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "❌ Adding Pending Delivery Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// ✅ API to send Pre-Approve Status
// export const sendPreApproveStatusAPI = async (payload) => {
//   try {
//     const response = await axios.post(
//       `${BASE_URL}api/mobile/resident/pre-approve-status/`,
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error(
//       "❌ Pre-Approve Status API Failed:",
//       error.response?.data || error.message
//     );
//     throw error;
//   }
// };

export const sendPreApproveStatusAPI = async (payload) => {
  try {
    const url = `${BASE_URL}/api/mobile/resident/pre-approve-status/`; // ✅ correct one
    console.log("🌐 Calling Pre-Approve API:", url);
    console.log("📦 Request Payload:", JSON.stringify(payload, null, 2));

    const response = await axios.post(url, payload, {
      headers: { "Content-Type": "application/json" },
    });

    console.log("✅ Pre-Approve API Response:", response);
    console.log("✅ Pre-Approve API Response Data:", response.data);

    return response.data;
  } catch (error) {
    console.error("❌ Pre-Approve Status API Failed:");
    if (error.response) {
      console.error("📡 Status:", error.response.status);
      console.error("📡 Response Headers:", error.response.headers);
      console.error(
        "📡 Response Data:",
        JSON.stringify(error.response.data, null, 2),
      );
    } else {
      console.error("📡 Error Message:", error.message);
    }
    throw error;
  }
};

// ─── Fetch Company Logos and Names ─────────────────────────────────────────────
export const fetchCompaniesAPI = async () => {
  try {
    // GET request to /api/mobile/companies/
    const response = await axios.get(`${BASE_URL}/api/mobile/companies/`);

    // The endpoint returns { success: true, data: [ … ] }, so we return the inner array:
    return response.data?.data || [];
  } catch (error) {
    // console.error(
    //   "❌ Company Fetch Error:",
    //   error.response?.data || error.message
    // );
    throw error;
  }
};

export const fetchPendingDeliveries = async () => {
  try {
    const url = `${BASE_URL}/api/mobile/delivery/pending-deliveries/`;
    console.log("🌐 Calling PendingDeliveries API:", url);

    // If you have an axiosInstance
    const response = await axiosInstance.get(url, {
      headers: { "Content-Type": "application/json" },
    });

    console.log("✅ PendingDeliveries API Response:", response);
    console.log("✅ PendingDeliveries API Response Data:", response.data);

    return response.data;
  } catch (error) {
    console.error("❌ PendingDeliveries Status API Failed:");
    if (error.response) {
      console.error("📡 Status:", error.response.status);
      console.error("📡 Response Headers:", error.response.headers);
      console.error(
        "📡 Response Data:",
        JSON.stringify(error.response.data, null, 2),
      );
    } else {
      console.error("📡 Error Message:", error.message);
    }
    throw error;
  }
};

export const fetchDeliveryProfile = async () => {
  try {
    console.log("📤 Fetching delivery profile...");

    const response = await axiosInstance.get(
      "/api/mobile/delivery/update-profile/",
    );

    return response.data;
  } catch (error) {
    console.error("❌ Failed to fetch delivery profile.");
    console.error("❗ Error details:", error.response?.data || error.message);
    throw error;
  }
};

// PATCH request to update delivery profile
export const patchDeliveryProfile = async (updatedData) => {
  try {
    const response = await axiosInstance.patch(
      `${BASE_URL}/api/mobile/delivery/update-profile/`,
      updatedData,
    );

    return response.data;
  } catch (error) {
    console.error(
      "❌ Delivery profile update error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const fetchSessionHistory = async () => {
  try {
    const url = `${BASE_URL}/api/mobile/delivery/session-history/`;
    console.log("🌐 Calling SessionHistory API:", url);

    // If you have an axiosInstance
    const response = await axiosInstance.get(url, {
      headers: { "Content-Type": "application/json" },
    });

    console.log("✅ SessionHistory API Response:", response);
    console.log("✅ SessionHistory API Response Data:", response.data);

    return response.data;
  } catch (error) {
    console.error("❌ SessionHistory API Failed:");
    if (error.response) {
      console.error("📡 Status:", error.response.status);
      console.error("📡 Response Headers:", error.response.headers);
      console.error(
        "📡 Response Data:",
        JSON.stringify(error.response.data, null, 2),
      );
    } else {
      console.error("📡 Error Message:", error.message);
    }
    throw error;
  }
};
